import React from "react";
import PropTypes from "prop-types";
import styles from "./ForgottenPassword.module.scss";
import GenericFormContainer from "../../../helpers/GenericFormContainer";
import { Validations } from "../../../helpers/validations";

import { UserService } from "../../../services/UserService";

import AuthGeneric from "../../../components/Auth/layouts/AuthGeneric";
import CostumInput from "../../../components/Auth/atoms/forms/InputCostum";
import RoundedButton from "../../../components/Auth/atoms/buttons/RoundedButton";
import Logo from "../../../components/Auth/atoms/images/Logo";
import i18n from "i18n";

export class ForgottenPasswordView extends GenericFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      userData: {
        email: null,
      },
      buttonState: "disabled",
    };
  }

  handleGoBack = () => {
    this.props.history.goBack();
  };

  handleChange = (e) => {
    let id = e.target.id;
    let userData = { ...this.state.userData };
    userData[id] = e.target.value;
    this.setState(
      {
        userData: userData
      }
    );
  };

  handleBlur = (event) => {
    let userData = { ...this.state.userData };
    this.validateFieldsAfterChange(userData);
  }

  validateFieldsAfterChange = (userData) => {
    let errors = { ...this.state.errors };

    if (!Validations.email(userData.email) && userData.email !== "") {
      errors.email = i18n.t("enter.valid.email");
    } else {
      errors.email = null;
    }

    this.setState(
      {
        errors,
      },
      (_) => {
        this.updateButtonState(userData);
      }
    );
  };

  updateButtonState = (userData) => {
    if (userData.email && !this.state.errors.email) {
      this.setState({
        buttonState: "enabled",
      });
    } else {
      this.setState({
        buttonState: "disabled",
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.beforeSubmit();
    const data = {
      email: this.state.userData.email,
    };
    UserService.resetPassword(data)
      .then((data) => {
        this.afterSubmit();
        this.props.history.push({
          pathname: "/email-verification",
          state: {
            email: this.state.userData.email,
            type: "forgot",
          },
        });
      })
      .catch((error) => {
        this.afterSubmit();
        this.dealWithError(error, i18n.t("there.was.error"));
      });
  };

  render() {
    const content = (
      <div className={styles["forgotten-password"]}>
        <form onSubmit={this.handleSubmit}>
          <Logo></Logo>
          <p className={styles["title"]}>
            <i className={"icon-back " + styles["forgotten-password-back"]} onClick={this.handleGoBack}></i>{i18n.t("forgot.password")}
          </p>
          <p className={styles["subtitle"]}>
            {i18n.t("enter.email.to.reset.password")}
          </p>
          <div className={styles["form-container"]}>
            <div className={styles["inputs-wrapper"]}>
              <CostumInput
                placeholder={i18n.t("email")}
                icon="icon-mail"
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
                id={"email"}
                error={this.state.errors.email}
              ></CostumInput>
            </div>
          </div>
          <div className={styles["rounded-button-wrapper"]}>
            <RoundedButton
              legend={i18n.t("send")}
              handleClick={this.handleSubmit}
              state={this.state.buttonState}
            ></RoundedButton>
          </div>
        </form>
      </div>
    );

    return (
      <div className={styles["forgotten-password-container"]}>
        <AuthGeneric
          title={i18n.t("forgot.password")}
          version={"header"}
          content={content}
          handleGoBack={this.handleGoBack}
        ></AuthGeneric>
      </div>
    );
  }
}

ForgottenPasswordView.propTypes = {
  handleChange: PropTypes.func,
  label: PropTypes.string,
};

export default ForgottenPasswordView;
